import React from "react";
import "./Banner.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

function Banner() {
  return (
    <section className="home_banner">
      <div className="container">
        <div className="row">
          <div className="col-md-5 col-sm-6 col-6">
            <div className="banner_swiper_holder">
              <Swiper navigation={true} modules={[Navigation]} className="banner_text_img_slider mySwiper_common_swiper">
                <SwiperSlide>
                  <div className="text_holder">
                    <h3>All-in-One Platform !</h3>
                    <h6>for Your Daily Needs</h6>
                    <p>Recharge, pay bills, earn rewards, and manage everything in one place – fast, simple, and secure.</p>
                  </div>
                </SwiperSlide>


                <SwiperSlide>
                  <div className="text_holder">
                    <h3>All-in-One Platform !</h3>
                    <h6>for Your Daily Needs</h6>
                    <p>Recharge, pay bills, earn rewards, and manage everything in one place – fast, simple, and secure.</p>
                  </div>
                </SwiperSlide>



                <SwiperSlide>
                  <div className="text_holder">
                    <h3>All-in-One Platform !</h3>
                    <h6>for Your Daily Needs</h6>
                    <p>Recharge, pay bills, earn rewards, and manage everything in one place – fast, simple, and secure.</p>
                  </div>
                </SwiperSlide>

              </Swiper>
            </div>
          </div>

          <div className="col-md-5 col-sm-6 col-6">
            <div className="img_bar_holder">
              <div className="img_holder">
                <img src="/assets/images/home/banner/home_banner.png" alt="home banner" className="banner_img" />
              </div>

              <div className="bar_holder"> <h6>AI. ORIGIN</h6></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
